{
  "alert": "Предупреждение",
  "dismiss": "Пропустить"
}
